export default {"src":"/_next/static/media/pcos-norge-logo-dark.972d93b1.svg","height":26,"width":157,"blurWidth":0,"blurHeight":0};